import React, { useState, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Record from './Record';

import {
  Card,
  CardContent,
  makeStyles,
  Box,
  Button,
  Menu,
  MenuItem,
  Grid,
  Typography
} from '@material-ui/core';

import SaveIcon from '@material-ui/icons/Save';


const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  button: {
    margin: theme.spacing(1),
  }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Results = ({ resultSet, resultModes, icon, vision, selectedMode, openEdition, openDeletion, openTreatment, openExportDialog, changeSort, values, openPrint, openMapaRota, printItem }) => {

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (event.currentTarget.id == 'excel' || event.currentTarget.id == 'csv' || event.currentTarget.id == 'pdf') {
      openExportDialog(event.currentTarget.id);
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Box mt={1}>
        {(resultModes[MODE_COMPACT].export != LEVEL_ACCESS_HIDE) ? (
          <Card width="100%">
            <CardContent classes={classes.actionspace} >
              <Grid
                container
              >
                <Grid item>
                  <Fragment>
                    <Button
                      disabled={resultModes[MODE_COMPACT].export == LEVEL_ACCESS_DISABLED}
                      variant="contained"
                      color="secondary"
                      size="small"
                      className={classes.button}
                      startIcon={<SaveIcon />}
                      aria-controls="simple-menu" component="span" aria-haspopup="true" onClick={handleClick}>
                      Exportar
                    </Button>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <MenuItem onClick={handleClick} name="excel" id="excel" >Planilha do Excel</MenuItem>
                      <MenuItem onClick={handleClick} name="csv" id="csv" disabled>Arquivo de Texto CSV</MenuItem>
                      <MenuItem onClick={handleClick} name="csv" id="pdf" disabled>Arquivo PDF</MenuItem>
                    </Menu>
                  </Fragment>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ) : ('')}
        <br></br>
        <Grid
          container
          spacing={2}
        >
          {resultSet.rows.map((item) => (
            <Record
              icon={icon}
              item={item}
              vision={vision}
              resultMode={resultModes[MODE_COMPACT]}
              openEdition={openEdition}
              openDeletion={openDeletion}
              openTreatment={openTreatment}
              openExportDialog={openExportDialog}
              slas={resultSet.slas}
              openPrint={openPrint}
              printItem={printItem}
              openMapaRota={openMapaRota}>
            </Record>
          ))}
        </Grid>

        {resultSet.rows.length == 0 ?
          <Grid>
            <Typography>{resultModes[MODE_COMPACT].empty}</Typography>
          </Grid>
          : ""}

      </Box>

    </Fragment >
  );
};

export default Results;
